import React, { useEffect }  from 'react';
import { Alert, Card, CardContent, Grid, Typography } from '@mui/material'
import { blue } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import ProfessionalCovenants from 'src/Professional/ProfessionalCovenants';
import ProfessionalName from 'src/Professional/ProfessionalName';
import ProfessionalPhoto from 'src/Professional/ProfessionalPhoto';
import ProfessionalSpecialities from 'src/Professional/ProfessionalSpecialities';
import { serializeDateFormatLong } from 'src/shared/global/helpers';
import { hourSelectedState } from 'src/store/reservation/reservationState';
import useSEO from 'src/Hooks/useSEO'
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";

const Success = () => {
  const hourSelected = useRecoilValue(hourSelectedState);
  //const history = useNavigate();
  const navigate = useNavigate();

  useSEO({title: 'Reserva exitosa'})

  useEffect(() => {
    if (hourSelected === null) {
      //history.push(process.env.REACT_APP_ROOT_SERVER_PATH)
      navigate(process.env.REACT_APP_ROOT_SERVER_PATH)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hourSelected])

  useEffect(() => {
    //ReactGA.pageview(process.env.REACT_APP_ROOT_SERVER_PATH + '/reserva-exitosa');
    ReactGA.send({ hitType: "pageview", page: process.env.REACT_APP_ROOT_SERVER_PATH + '/reserva-exitosa' });
  }, [])

  return (
    <Grid container>

      <Alert sx={{ my: 2 }}>Hemos enviado un correo electrónico a <b>{hourSelected?.emailPaciente}</b> con la confirmación de su reserva de hora (Si no lo encuentra en su bandeja, revise su bandeja de Spam).</Alert>

      <Grid container spacing={{ xs: 1, md: 2 }}>
        <Grid item xs={12} md={7}>
          <Card sx={{ mb: 1, }}>
            <CardContent sx={{ display: "flex", alignItems: "flex-start" }}>
              <span style={{ fontSize: "3rem" }}>🗓</span>
              <div style={{ marginLeft: "1rem" }}>
                <h2>{serializeDateFormatLong(hourSelected?.hourSelected?.ageFecha, true)}</h2>
                <h4 style={{ color: blue[500], }}>{hourSelected?.hourSelected?.ageInicio} hrs.</h4>
              </div>
            </CardContent>
          </Card>

          <Card sx={{ mb: 1, }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <ProfessionalPhoto image={hourSelected?.professional?.imagen} alt={hourSelected?.professional?.ptdNombre}
                especialidades={hourSelected?.professional?.especialidades}
                width={51}
                height={74}
                widthIconHeader={20}
                heightIconHeader={20}
              />

              <Grid
                item
                container
                md={12}
                style={{
                  marginLeft: 12,
                }}
              >
                <Grid item md={12}>
                  <ProfessionalName fontSize={24} nameProfessional={hourSelected?.professional?.ptdNombre} />
                  <ProfessionalSpecialities fontSize={16} specialities={hourSelected?.professional?.especialidades} />
                  {
                    hourSelected?.pisoBox?.abaPiso && (
                      <Typography
                        style={{
                          fontSize: 16,
                          fontWeight: "bold"
                        }}
                      >
                        {hourSelected?.pisoBox?.atbNombre} - Piso {hourSelected?.pisoBox?.abaPiso} - {hourSelected?.pisoBox?.abaDescrip}
                      </Typography>
                    )
                  }
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <ProfessionalCovenants covenants={hourSelected?.professional?.convenios} fontSize={16} />
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: "bold"
                }}
              >
                Valor particular:
              </Typography>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                }}
              >
                {hourSelected?.professional?.valorParticular?.replace(",", ".") || "No especificado"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={5}>
          <Card>
            <CardContent>
              <h3>👉 Recomendaciones:</h3>
              <ul style={{ marginLeft: "1rem" }}>
                <li>Llegar 15 minutos antes de la hora reservada.</li>
                <li>Anular al menos un dia antes de su cita.</li>
              </ul>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

    </Grid >
  )
}

export default Success
